import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { IdTypeList, idTypeRoutes } from '../../models/id-type.const';

@Component({
  selector: 'app-search-by-id',
  templateUrl: './search-by-id.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class SearchByIdComponent implements OnInit {
  public error = '';

  constructor(public router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const fullId: string = this.activatedRoute.snapshot.params.id;
    if (fullId.length < 6) {
      this.error = 'You have the wrong id!';
      return;
    }

    let idType = '';
    let id: number;

    if (isNaN(parseInt(fullId[0], 10))) {
      idType += fullId[0];
    } else {
      this.error = 'You have the wrong id!';
      return;
    }
    if (isNaN(parseInt(fullId[1], 10))) {
      // type with 2 letters
      idType += fullId[1];
      id = parseInt(fullId.slice(2), 10);
    } else {
      // type with 1 letter
      id = parseInt(fullId.slice(1), 10);
    }

    const route = idTypeRoutes[idType as IdTypeList];

    if (route === undefined) {
      this.error = 'You have the wrong id!';
      return;
    }
    if (route === '') {
      this.error =
        'At the moment, this type of id is not supported for search!';
      return;
    }

    this.router.navigate(['/', route, id]);
  }
}
